<template>
  <div class="my-1" v-if="order">
    <div class="row m-1">
      <div class="col-12">
        <div class="flex">
          <h2>
            <span class="badge badge-primary">
              {{ order.status_name }}
            </span>
          </h2>
        </div>
      </div>
    </div>

    <div class="row m-1">
      <div class="col-12 mt-3">
        <div class="flex">
          <strong>Tipo de entrega:</strong>
          {{ getTypeDelivery(order) }}
        </div>
        <div class="flex">
          <strong>Cliente:</strong>
          {{ order.customer }}
        </div>
        <div class="flex">
          <strong>Cocina:</strong>
          {{ order.dark_kitchen }}
        </div>
        <div class="flex">
          <strong>Telefono:</strong>
          {{ order.phone }}
        </div>
        <div class="flex">
          <strong>Fecha:</strong>
          {{ order.created_at }}
        </div>
        <div class="flex">
          <strong>Marca:</strong>
          {{ order.brand }}
        </div>
        <div class="flex">
          <strong>Hora pedido programado:</strong>
          {{ order.delivery_time_formatted }}
        </div>
      </div>
    </div>

    <div class="row  mb-4 mt-4">
      <div class="col-12 block">
        <div class="d-flex justify-content-end">
          <button type="button"
                  class="btn btn-primary block-sm"
                  @click="changeStatusModal = true"
                  :disabled="order.status_tracking_id === 3 || order.status_tracking_id === 6"
          >CAMBIAR STATUS</button>
        </div>
      </div>
    </div>

    <div class="card mt-4">
      <el-table :data="itemsTable.items" row-key="id" header-row-class-name="thead-light"
        v-if="itemsTable.items.length !== 0" @sort-change="sortChange">
        <el-table-column v-for="column in itemsTable.columns" :key="column.label" v-bind="column">
        </el-table-column>
      </el-table>
    </div>

    <div class="card p-3" v-if="orderDetails">
      <div class="row">
        <div class="col-12">
          <div class="flex" v-if="orderDetails.order.order_type_label">
            <strong>Tipo de pedido:</strong>
            {{ orderDetails.order.order_type_label }}
          </div>
          <div class="flex">
            <strong>Dirección:</strong>
            {{ orderDetails.order.address }}
          </div>
          <div class="flex">
            <strong> Tipo de entrega:</strong>
            {{ orderDetails.order.option_delivery }}
          </div>
          <div class="flex">
            <strong>Instrucciones: </strong>
            {{ orderDetails.order.reference }}
          </div>
        </div>
      </div>
    </div>

    <div class="card" v-if="orderDetails.order.order_delivery_feedback">
      <div class="card-header">
        <h2>Evidencia de entrega</h2>
      </div>
      <div class="card-body" v-if="orderDetails">
        <div class="row">
          <div class="col-12">
            <strong>Tipo de entrega:</strong>
            <span v-if="orderDetails.order.order_delivery_feedback
              .delivery_type_id == 1
              ">
              Dejar en recepción
            </span>
            <span v-else-if="orderDetails.order.order_delivery_feedback
              .delivery_type_id == 2
              ">
              Encontrarnos afuera
            </span>
            <div v-else>Otros:</div>
          </div>
          <div class="col-12" v-if="orderDetails.order.order_delivery_feedback
            .delivery_type_id == 3
            ">
            <strong>Descripcion de entrega:</strong>
            {{ orderDetails.order.order_delivery_feedback.message }}
          </div>
          <div class="col-12">
            <strong>Observaciones:</strong>
            {{
              orderDetails.order.order_delivery_feedback.observations
            }}
          </div>
        </div>
      </div>
    </div>

    <CustomModal :is-modal="changeStatusModal" @closeModal="changeStatusModal = false" :closeOuth="true" width="lg">
      <FoodcourtChangeStatus :showModal="changeStatusModal" @onOrderChange="onOrderChange"
        @closeModal="changeStatusModal = false" :order="order">
      </FoodcourtChangeStatus>
    </CustomModal>
  </div>
</template>
<script>

import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import BackofficeApi from "../../gateways/backoffice-api";
import CustomModal from "../../components/CustomModal";
import FoodcourtChangeStatus from "./FoodcourtChangeStatus.vue";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
} from "element-ui";

export default {
  name: "starter-page",
  props: {
    order: {
      type: Object, // Specify the type of the prop
      required: false // If the prop is required or not
    }
  },
  components: {
    StatsCard,
    RouteBreadCrumb,
    flatPicker,
    FoodcourtChangeStatus,
    CustomModal,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      changeStatusModal: false,
      orderDetails: null,
      itemsTable: {
        items: [],
        columns: [
          {
            prop: 'meal',
            label: 'Producto',
            minWidth: 150,
            sortable: true,
          },
          {
            prop: 'quantity',
            label: 'Cant.',
            minWidth: 110,
            sortable: true,
          },
          {
            prop: 'note',
            label: 'Nota',
            minWidth: 200,
            sortable: true,
          },
          {
            prop: 'sections',
            label: 'Agre.',
            minWidth: 150,
            sortable: true,
            formatter: (row, column, cellValue) => {
              return cellValue.map((section) => {
                return `${section.quantity} ${section.meal_section}`;
              }).join(', ');
            }
          },
        ],
      }
    };
  },
  mounted() {
  },
  computed: {
    host() {
      return process.env.VUE_APP_API_BACKOFFICE_URL.replace("/api/v1/", "");
    },
  },
  watch: {
    order: function (newVal, oldVal) {
      if (newVal && newVal != oldVal) this.loadOrderDetails(newVal);
    }
  },
  methods: {
    getTypeDelivery(order) {
      if(order.order_delivery_type === 'delivery') {
        return 'Domicilio';
      }else if(order.franchise_delivery_type === 'eat_here'){
        return 'Recojo - comer aqui'
      }
      return 'Recojo - llevar'
    },
    close() {
      this.$emit('closeModal');
    },
    onOrderChange(order) {
      this.$emit('onOrderChange', order);
    },
    async loadOrderDetails(order) {
      const path =
        this.host +
        "/api/v3/foodcourt/orders/show/" +
        order.id;
      const orderDetails = await BackofficeApi.get(path);
      this.orderDetails = orderDetails.data.detail.order_details;
      this.itemsTable.items = orderDetails.data.detail.order_details.items;
    },
    sortChange({ prop, order }) {
      if (prop) {
        this.itemsTable.items.sort((a, b) => {
          let aVal = a[prop]
          let bVal = b[prop]
          if (order === 'ascending') {
            return aVal > bVal ? 1 : -1
          }
          return bVal - aVal ? 1 : -1
        })
      } else {
        this.itemsTable.items.sort((a, b) => {
          return a.id - b.id
        })
      }
    },
  },
};
</script>
<style lang="scss">
.weight {
  width: 30%;
  border: 1px solid black;

  td,
  th,
  tr {
    border: 1px solid black;
  }
}
</style>
<style>
.noMargin {
  margin-bottom: 0rem;
}

.starter-page {
  min-height: calc(100vh - 380px);
}

.recipe img {
  max-width: 100%;
}

p {
  white-space: pre-line
}

@media screen {
  #print {
    display: none;
  }
}

@media print {
  body * {
    visibility: hidden;
  }

  #print,
  #print * {
    visibility: visible;
  }

  #print {
    position: absolute;
    left: 0;
    top: 0;
  }
}

@media all and (max-width:480px) {
  .block-sm {
    width: 100%;
    display: block;
  }
}
</style>
